import React from 'react';
var Alert = function (props) {
    var _a = props.variant, variant = _a === void 0 ? 'info' : _a, _b = props.message, message = _b === void 0 ? '' : _b, _c = props.description, description = _c === void 0 ? '' : _c, _d = props.showIcon, showIcon = _d === void 0 ? true : _d, _e = props.dismissable, dismissable = _e === void 0 ? true : _e, onDismiss = props.onDismiss, className = props.className;
    var getAlertClass = function (variant, dismissable) {
        return "alert alert-" + variant + " " + (dismissable && onDismiss ? ' alert-dismissible' : '');
    };
    var getAlertIconClass = function (variant) {
        switch (variant) {
            case 'warning':
                return 'fa-exclamation-triangle';
            case 'info':
                return 'fa-info-circle';
            case 'danger':
                return 'fa-exclamation-circle';
            case 'success':
            default:
                return 'fa-check-circle';
        }
    };
    return (React.createElement("div", { className: "" + getAlertClass(variant, dismissable) + (className ? " " + className : ''), role: "alert" },
        dismissable ? (React.createElement("button", { type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: function (nativeEvent) {
                return onDismiss && onDismiss(nativeEvent);
            } },
            React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))) : null,
        showIcon ? (React.createElement("i", { className: "fal " + getAlertIconClass(variant) + " " + variant })) : null,
        React.createElement("strong", null, message),
        " ",
        description));
};
export default React.memo(Alert);
